(() => {
  const onReady = () => {
    document.querySelectorAll('.deko-gallery__thumbs a').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const hero = document.querySelector('.deko-gallery__hero');
        if (!hero) return;
        hero.src = link.href;
        hero.srcset = '';
        document.querySelectorAll('.deko-gallery__thumbs a').forEach(item => item.classList.remove('is-active'));
        link.classList.add('is-active');
      });
    });
    const form = document.querySelector('#DekoProductForm');
    if (form) {
      const price = document.querySelector('[data-deko-current-price]');
      const compare = document.querySelector('[data-deko-compare-price]');
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(cents/100);
      const update = () => {
        form.querySelectorAll('.deko-bundle').forEach(bundle => {
          const selects = [...bundle.querySelectorAll('[data-deko-variant-select]')];
          const subtotal = selects.reduce((sum, select) => sum + Number(select.selectedOptions[0]?.dataset.price || 0), 0);
          const quantity = Number(bundle.querySelector('[name="deko_pack"]')?.value || 1);
          const factor = quantity === 2 ? .9 : quantity === 3 ? .75 : 1;
          const total = bundle.querySelector('[data-deko-total]');
          const original = bundle.querySelector('s');
          if (total) total.textContent = money(Math.round(subtotal * factor));
          if (original) original.textContent = money(subtotal);
          selects.forEach(select => {
            const image = select.closest('.deko-bundle-variant')?.querySelector('img');
            const url = select.selectedOptions[0]?.dataset.image;
            if (image && url) image.src = url;
          });
        });
        const active = form.querySelector('[name="deko_pack"]:checked')?.closest('.deko-bundle');
        const selected = active?.querySelector('[data-deko-variant-select]')?.selectedOptions[0];
        if (price && selected) price.textContent = money(Number(selected.dataset.price));
        const variantData = JSON.parse(document.querySelector('#DekoVariantData')?.textContent || '[]');
        const variant = variantData.find(item => String(item.id) === selected?.value);
        if (compare && variant?.compare_at_price) compare.textContent = money(variant.compare_at_price);
      };
      form.querySelectorAll('[data-deko-variant-select], [name="deko_pack"]').forEach(input => input.addEventListener('change', update));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = event.submitter;
        const active = form.querySelector('[name="deko_pack"]:checked')?.closest('.deko-bundle');
        const selects = [...(active?.querySelectorAll('[data-deko-variant-select]') || [])];
        const error = form.querySelector('.deko-form-error');
        if (error) { error.hidden = true; error.textContent = ''; }
        if (!selects.length) return;
        const items = selects.map(select => ({id:Number(select.value),quantity:1}));
        form.querySelectorAll('.deko-buy-actions button').forEach(item => item.disabled = true);
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Please check your options and try again.');
          window.location.assign(window.Shopify.routes.root + (button?.name === 'checkout' ? 'checkout' : 'cart'));
        } catch (reason) {
          if (error) { error.textContent = reason.message; error.hidden = false; }
          form.querySelectorAll('.deko-buy-actions button').forEach(item => item.disabled = false);
        }
      });
      update();
    }
    document.querySelectorAll('[data-deko-sort]').forEach(select => {
      const active = new URL(location.href).searchParams.get('sort_by');
      if (active && [...select.options].some(option => option.value === active)) select.value = active;
      select.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', select.value);
        location.href = url.toString();
      });
    });
    const filterToggle = document.querySelector('.deko-filter-mobile');
    const filterPanel = document.querySelector('.deko-filter');
    filterToggle?.addEventListener('click', () => {
      const open = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
